import { render } from "./DiceThree.vue?vue&type=template&id=4a5b6cce"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/DiceThree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a5b6cce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a5b6cce', __exports__)) {
    api.reload('4a5b6cce', __exports__)
  }
  
  module.hot.accept("./DiceThree.vue?vue&type=template&id=4a5b6cce", () => {
    api.rerender('4a5b6cce', render)
  })

}


export default __exports__